import { render, staticRenderFns } from "./default-nav.vue?vue&type=template&id=45c91396&scoped=true&"
import script from "./default-nav.vue?vue&type=script&lang=ts&"
export * from "./default-nav.vue?vue&type=script&lang=ts&"
import style0 from "./default-nav.vue?vue&type=style&index=0&id=45c91396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c91396",
  null
  
)

export default component.exports